module.exports = __webpack_public_path__ + "static/media/f1.af3aa2fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/f1.jpg
// module id = 394
// module chunks = 0